document.addEventListener('DOMContentLoaded', function () {
    // Remove html.no-js
    jQuery('html').removeClass('no-js');
});
